import { useEffect, useRef } from 'react';

const isTyping = () => {
  const el = document.activeElement;
  return !!el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);
};

// Actualiza una pantalla cada `intervalMs` sin recargarla: no consulta con la pestaña oculta, se
// actualiza al volver a ella y se salta la vuelta si `paused` (diálogo abierto) o si el usuario
// está escribiendo, para no perder lo que tiene en pantalla.
export const useAutoRefresh = (refresh, { intervalMs = 60000, paused = false } = {}) => {
  const refreshRef = useRef(refresh);
  const pausedRef = useRef(paused);
  refreshRef.current = refresh;
  pausedRef.current = paused;

  useEffect(() => {
    const tick = () => {
      if (document.hidden || pausedRef.current || isTyping()) return;
      refreshRef.current();
    };
    const interval = setInterval(tick, intervalMs);
    const handleVisibility = () => { if (!document.hidden) tick(); };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [intervalMs]);
};
